import React from 'react';
import 'react-toastify/dist/ReactToastify.css';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { SelectInput } from '../CustomerAccounts/LoanFormFields';

// Add / edit a component activity of a construction plan (side panel).
// Same fields and handlers as before.
export default function ComponentActivitiesConfigForm({
  componentId,
  activityId, isApplicable,
  setComponentId,
  setActivityId, setApplicable,
  componentConfig,
  activityConfig,
}) {
  return (
    <div className='lf-grid'>
      <SelectInput
        id='componentId'
        label='Component'
        span={12}
        options={componentConfig.map((element) => ({
          value: element.id, label: element.componentName,
        }))}
        value={componentId}
        onChange={(event) => setComponentId(event)}
      />
      <SelectInput
        id='activityId'
        label='Activity'
        span={12}
        options={activityConfig.filter((item) => item.activityTypeId === 3).map((element) => ({
          value: element.id, label: element.activityName,
        }))}
        value={activityId}
        onChange={(event) => setActivityId(event)}
      />
      <div className='lf-span-12'>
        <FormControlLabel
          control={(
            <Checkbox
              color='primary'
              size='small'
              checked={isApplicable === 'TRUE'}
              onChange={(event) => setApplicable(event)}
              name='Applicable'
            />
          )}
          label='Applicable'
        />
      </div>
    </div>
  );
}
